<template>
  <div class="promotion">
    <div class="promotion-content">
      <Header />

      <div class="intro-box">
        <img src="@assets/promotion/intro-img.jpg" alt="" />
        <div class="absolute">
          <div class="intro-vip">-唯品会旗下唯代购-</div>
          <div class="intro-title">货品中台合作渠道招募</div>
          <div class="hot-wrap">
            <img class="hot-img" src="@assets/promotion/hot.png" alt="" />
            <img class="hot-img hot-animation" src="@assets/promotion/hot-animation.png" alt="" />
          </div>
        </div>
      </div>

      <div class="promotion-title">用户群体</div>
      <div class="group">
        <img src="@assets/promotion/group-img.png" alt="" />
        <div class="group-content">
          <div class="group-title">唯代购货品中台项目主要面向三类合作伙伴开放合作申请：</div>
          <div class="group-list">
            <div class="group-item">
              <span class="group-num">1.</span>拥有流量但货品体系不完善的私域电商，唯代购货品中台开放全品类6000+品牌，帮助私域流量提升变现能力。
            </div>
            <div class="group-item">
              <span class="group-num">2.</span>拥有高粘性应用场景的积分平台，唯代购货品中台提供具有完整授权链路的国内外大品牌和正品保障，帮助其进一步提高用户粘性，并实现灵活的支付结算体系，与合作伙伴共享平台资源。
            </div>
            <div class="group-item">
              <span class="group-num">3.</span>有批量采购需求的各类型企业，唯代购货品中台提供系统化流程和完整的订单票据，帮助企业快速采购到高性价比的货品。
            </div>
          </div>
        </div>
      </div>


      <div class="promotion-title">用户痛点</div>
      <div class="flex-center user-pain">
        <div class="flex-center user-pain-item">
          <img src="@assets/promotion/private-shop.png" alt="" />
          <div class="user-pain-item-title">私域电商</div>
          <div class="user-pain-li" style="margin-left: 70rem">· 无法对接全品类商品</div>
          <div class="user-pain-li" style="margin-left: 70rem">· 需要品质保障，售后无忧</div>
        </div>
        <div class="flex-center user-pain-item">
          <img src="@assets/promotion/point-welfare.png" alt="" />
          <div class="user-pain-item-title">积分福利</div>
          <div class="user-pain-li">· 大品牌引进困难，商品无法满 足用户需求</div>
          <div class="user-pain-li">· 需要完整授权链路，正品保障</div>
        </div>
        <div class="flex-center user-pain-item">
          <img src="@assets/promotion/company-purchase.png" alt="" />
          <div class="user-pain-item-title">企业采购</div>
          <div class="user-pain-li">· 询价困难，采购价格无优势</div>
          <div class="user-pain-li">· 需要系统化流程，需要提供 完整的订单票据解决方案</div>
        </div>
      </div>

      <div class="promotion-title">解决方案</div>
      <div class="flex-center solution">
        <div class="solution-column">
          <div class="solution-text">货品分类</div>
          <div class=" flex-center solution-item-wrap">
            <div class="solution-column-box">
              <div class="solution-block solution-small-block">快时尚</div>
              <div class="solution-block solution-small-block">轻重奢</div>
              <div class="solution-block solution-small-block">国内专柜</div>
            </div>
            <img class="arrow" src="@assets/promotion/arrow.png" alt="箭头" />
          </div>
        </div>
        <div class="solution-column">
          <div class="solution-text">连接方式</div>
          <div class=" flex-center solution-item-wrap">
            <div class="solution-column-box solution-border">
              API/ CPS
            </div>
            <img class="arrow" src="@assets/promotion/arrow.png" alt="箭头" />
          </div>
        </div>
        <div class="solution-column">
          <div class="solution-text">&nbsp;</div>
          <div class=" flex-center solution-item-wrap">
            <div class="solution-column-box solution-border solution-red">
              唯代购货品中台
            </div>
            <img class="arrow" src="@assets/promotion/arrow.png" alt="箭头" />
          </div>
        </div>
        <div class="solution-column">
          <div class="solution-text">客户</div>
          <div class=" flex-center solution-item-wrap">
            <div class="solution-row-box solution-big-box">
              <div class="solution-big-column">
                <div class="flex-center">
                  <div class="flex-center solution-big-border solution-shadow-border">
                    独立电商平台<br />
                    （自建交易端）
                  </div>
                  <img class="column-arrow" src="@assets/promotion/arrow.png" alt="箭头" />
                </div>
                <div class="flex-center">
                  <div class="flex-center solution-big-border solution-shadow-border">
                    平台<br />
                    电商店铺
                  </div>
                  <img class="column-arrow" src="@assets/promotion/arrow.png" alt="箭头" />
                </div>
              </div>
              <div class="solution-big-column">
                <div class="flex-center solution-small-border solution-shadow-border">
                  APP/小程序
                </div>
                <div class="flex-center solution-small-border solution-shadow-border">
                  品牌抖音/ <br />
                  快手小店
                </div>
                <div class="flex-center solution-small-border solution-shadow-border">
                  MCN、直播服 <br />
                  务商 <br />
                  抖音/快手小店
                </div>
              </div>
              <img class="column-arrow" src="@assets/promotion/arrow.png" alt="箭头" />
              <div class="solution-big-column">
                <div class="flex-center solution-long-border solution-shadow-border">
                  消费者
                </div>
              </div>
            </div>
            <img class="arrow" src="@assets/promotion/arrow.png" alt="箭头" />
          </div>
        </div>
        <div class="solution-column">
          <div class="solution-text">价值</div>
          <div class=" flex-center solution-item-wrap">
            <div class="solution-column-box">
              <div class="solution-block solution-middle-block">
                低价<br />
                深库存<br />
                商品丰富度<br />
              </div>
              <div class="solution-block solution-middle-block">
                仓配售后<br />
                服务提升<br />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="promotion-title promotion-about-title">
        关于我们
        <div class="wpc-desc">唯代购货品中台是唯品会旗下的专业货品供应链品牌，2018年8月15日正式上线，致力于为合作伙伴提供一站式货品供应链解决方案。</div>
      </div>
      <div class="about">
        <img src="@assets/promotion/about-img.png" alt="" />
        <div class="about-content">
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-1.png" alt="" />
            唯品会战略<br />目标
          </div>
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-2.png" alt="" />
            6年行业服务<br />经验
          </div>
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-3.png" alt="" />
            专注100+企业<br />服务过亿用户
          </div>
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-4.png" alt="" />
            全部商品<br />PICC承保
          </div>
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-5.png" alt="" />
            2000+专业买手<br />好货低价
          </div>
          <div class="flex-center about-item">
            <img src="@assets/promotion/about-6.png" alt="" />
            全国7大物流中心<br />快速配送
          </div>
        </div>
      </div>

      <div class="promotion-title">- 6000+合作品牌 -</div>
      <div class="brand">
        <div class="swiper">
          <div class="swiper-container">
            <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-1.png" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-2.png" alt="" />
            </div>
            <div class="swiper-slide">
              <img src="@assets/promotion/brand-3.png" alt="" />
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
      </div>

      <div class="promotion-title">电商供应链赋能</div>
      <div class="shop">
        <img src="@assets/promotion/shop-img.png" alt="" />
        <div class="shop-content">
          <div class="shop-item">
            <div class="shop-item-title">1.智能选品</div>
            <div>海量大数据分析驱动 智能选品</div>
          </div>
          <div class="shop-item">
            <div class="shop-item-title">2.极速上架</div>
            <div>无需编辑图文，一键 导入上架</div>
          </div>
          <div class="shop-item">
            <div class="shop-item-title">3.高效定价</div>
            <div>高效批量定价，灵活 把控利润</div>
          </div>
          <div class="shop-item">
            <div class="shop-item-title">4.实时同步</div>
            <div>实时同步商品、看订 单及售后状态</div>
          </div>
          <div class="shop-item">
            <div class="shop-item-title">5.自动下单</div>
            <div>订单自动处理，物流 同步跟踪</div>
          </div>
          <div class="shop-item">
            <div class="shop-item-title">6.风控保证</div>
            <div>严控商品质量，拦截 异常订单</div>
          </div>
        </div>
      </div>

      <div class="promotion-title">合作案例</div>
      <div class="example-content">
        <div class="example-bar">
          <div
            class="bar-item"
            :class="{'bar-item-active': activeIndex === index}"
            v-for="(item, index) in barData"
            :key="index"
            @click="changActiveIndex(index)">
            {{item.label}}
          </div>
        </div>
        <div class="example-panel">
          <div class="example-panel-left">
            <img :src="barData[activeIndex].img" alt="" />
          </div>
          <div class="example-panel-right">
            <div class="panel-right-title">{{barData[activeIndex].title}}</div>
            <div class="panel-right-text" v-html="barData[activeIndex].text"></div>
          </div>
        </div>
      </div>


      <div class="partner-box">
        <img src="@assets/promotion/partner-img.png" alt="" />
        <div class="partner-content">
          <div class="partner-item">
            <div>商业合作：</div>
            <div class="left-info">电话：020-22330962</div>
            <div class="left-info">邮箱：elieen.lee@vipshop.com</div>
          </div>
          <div class="partner-item partner-right">
            企业微信：
            <img class="qr-code" src="@assets/promotion-h5/qr-code.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <FloatRight :visible="showFloatRight" />
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import Header from '@/components/PromotionHeader.vue'
import Footer from '@/components/PromotionFooter.vue'
import FloatRight from '@/components/FloatRight.vue'
import {EXAMPLE_DATA} from '@/config/constants'
import util from '@/utils'

export default {
  name: 'promotion',
  components: {
    Header,
    Footer,
    FloatRight,
  },
  data() {
    return {
      barData: EXAMPLE_DATA,
      activeIndex: 0,
      showFloatRight: false,
    }
  },
  created() {
    util.setPCHtmlFontSize()
  },
  mounted() {
    window.addEventListener('scroll', this.scroll, true)
    setTimeout(() => {
      let mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal', //滑动方向，可设置水平(horizontal)或垂直(vertical)。
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        paginationClickable: true,
        observer: true,
        observeParents: true
      })
    }, 500)

    this.$tracker.page('wdg_page_official_website', {
      page_id: 1 // business cooperation 商务合作
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.showFloatRight = scrollTop > 1000
    },
    changActiveIndex(index) {
      if (index === this.activeIndex)return

      this.activeIndex = index
    }
  }
}
</script>
<style>
.panel-right-text div {
  text-indent: 40rem;
  line-height: 36rem;
}
</style>
<style lang="stylus" scoped>
.promotion {
  width: 100%;
  min-width: 1000px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;

  .promotion-content {
    min-height: calc(100vh - 80rem);
  }

  .content {
    min-width: 900rem;
  }

  .absolute {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .intro-box {
    margin-top: 2rem;
    width: 100%;
    height: 542rem;
    position: relative;
    .intro-vip {
      margin-top: 100rem;
      color: #fff;
      font-size: 40rem;
      text-align: center;
    }
    .intro-title {
      margin-top: 10rem;
      color: #fff;
      font-size: 80rem;
      font-weight: bold;
      text-align: center;
      text-shadow: 0rem 2rem 20rem rgba(0, 0, 0, 0.5);
    }
    .hot-wrap {
      position: relative;
      width: 330rem;
      height: 80rem;
      margin: 30rem auto 0;
    }
    .hot-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
    }
    .hot-animation {
      z-index: 11;
      animation: blown 1.3s infinite;
    }
    @keyframes blown {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(1.4);
        opacity: 0;
      }
    }
  }

  .promotion-title {
    width: 100%;
    height: 120rem;
    // line-height: 120rem;
    // text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(270deg, #FFFFFF 0%, #F5F5F5 50%, #FFFFFF 100%);
    color: #000;
    font-size: 40rem;
  }
  .promotion-about-title {
    flex-direction: column;
    height: 220rem;
  }

  .wpc-desc {
    margin-top: 15rem;
    width: 100%;
    padding: 0 22%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24rem;
    line-height: 33rem;
    color: #333;
    text-align: center;
  }
  // 用户群体
  .group {
    position: relative;
    width: 100%;
    height: 650rem;
    .group-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 65rem 0;
      box-sizing: border-box;
      color: #333;
      .group-title {
        font-size: 40rem;
        text-align: center;
        margin-bottom: 70rem;
        font-weight: 500;
      }
      .group-list {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
      }
      .group-item {
        width: 320rem;
        height: 350rem;
        background: #fff;
        border-radius: 10rem;
        margin-right: 50rem;
        font-size: 22rem;
        line-height: 32rem;
        padding: 36rem 39rem;
        box-sizing: border-box;
        .group-num {
          font-size: 40rem;
          margin-right: 4rem;
          font-weight: 500;
        }
      }
      .group-item:last-child {
        margin-right: 0;
      }
    }
  }

  // 用户痛点
  .user-pain {
    padding: 90rem 0 80rem;

    .user-pain-item {
      width: 310rem;
      flex-direction: column;
      margin-right: 115rem;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 160rem;
        height: 160rem;
      }
      .user-pain-item-title {
        font-size: 30rem;
        color: #000;
        margin-bottom: 40rem;
      }
      .user-pain-li {
        width: 100%;
        text-align: left;
        font-size: 20rem;
        color: #666;
        text-indent: 5rem;
      }
    }
  }

  .arrow {
    position: absolute;
    right: -10rem;
    top: 50%;
    transform: translate(100%, -50%);
    width: 30rem;
    height: 27rem;
  }
  // 解决方案
  .solution {
    padding: 85rem 20rem 80rem;

    .solution-column {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 26rem;
      margin-right: 50rem;
      .solution-text {
        color: #E4007F;
        margin-bottom: 20rem;
      }
      .solution-item-wrap {
        position: relative;
        height: 390rem;
        .solution-column-box {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          .solution-block {
            width: 130rem;
            border: 2rem solid #EBEBEB;
            border-radius: 10rem;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          }
          .solution-small-block {
            height: 110rem;
          }
          .solution-middle-block {
            height: 180rem;
            font-size: 20rem;
            box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.1);
          }
        }
        .solution-border {
          width: 115rem;
          border: 2rem solid #EBEBEB;
          border-radius: 10rem;
          justify-content: center;
          padding: 0 30rem;
          text-align: center;
        }
        .solution-red {
          background: #F90080;
          color: #fff;
        }
        .solution-row-box {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center
        }
        .column-arrow {
          width: 30rem;
          height: 27rem;
          margin-left: 3rem;
          margin-right: 6rem;
        }
        .solution-big-box {
          padding: 25rem 17rem;
          box-sizing: border-box;
          border: 1rem dashed #F90080;
          border-radius: 10rem;
          .solution-big-column {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            .solution-big-border {
              width: 155rem;
              height: 160rem;
            }
            .solution-small-border {
              width: 155rem;
              height: 100rem;
            }
            .solution-long-border {
              width: 70rem;
              height: 100%;
              padding: 0 20rem;
              box-sizing: border-box;
            }
            .solution-shadow-border {
              text-align: center;
              font-size: 20rem;
              box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.1);
              border-radius: 10rem;
            }
          }
        }
      }
    }
  }

  // 关于我们
  .about {
    position: relative;
    width: 100%;
    height: 700rem;
    .about-content {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 880rem;
      height: 100%;
      padding: 80rem 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: space-between;
      flex-wrap: wrap;
      .about-item {
        width: 33.33%;
        flex-direction: column;
        font-size: 26rem;
        color: #fff;
        text-align: center;
        img {
         width: 140rem;
         height: 140rem;
         margin-bottom: 30rem; 
        }
      }
    }
  }

  // 合作品牌
  .brand {
    width: 800rem;
    height: 370rem;
    margin: 40rem auto 40rem;
  }
  .swiper {
    width: 100%;
    height: 100%;
    z-index: 9;
    .swiper-container {
      width: 100%;
      height: 100%;
      /deep/ .swiper-pagination-bullet {
        width: 12rem;
        height: 12rem;
      }
      /deep/ .swiper-pagination-bullet-active {
        background: #e1017e;
      }
    }
    img {
      width: 100%;
      height: 308rem;
    }
  }
  // 电商供应链赋能
  .shop {
    position: relative;
    width: 100%;
    height: 650rem;
    .shop-content {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 1100rem;
      height: 100%;
      padding: 110rem 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: space-between;
      flex-wrap: wrap;
      .shop-item {
        width: 320rem;
        height: 180rem;
        margin-right: 70rem;
        background: rgba(39, 0, 61, 0.5);
        border-radius: 10rem;
        padding: 28rem 40rem;
        color: rgba(255, 255, 255, .6);
        font-size: 26rem;
        box-sizing: border-box;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .shop-item-title {
          color: #fff;
          font-weight: bold;
          font-size: 30rem;
          margin-bottom: 10rem;
        }
      }
    }
  }

  // 合作案例
  .example-content {
    width: 100%;

    .example-bar {
      width: 100%;
      height: 70rem;
      background: #fff;
      padding: 0 20rem;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      .bar-item {
        height: 60rem;
        line-height: 60rem;
        font-size: 26rem;
        color: #666;
        padding: 0 20rem;
        margin-right: 60rem;
        border-bottom: 4rem solid #fff;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .bar-item-active {
        border-color: #F90080;
        color: #F90080;
      }
    }

    .example-panel {
      width: 100%;
      height: 870rem;
      background: url('../assets/promotion/example-bg.png') no-repeat top center;
      background-size cover;
      display: flex;
      justify-content: center;

      .example-panel-left {
        width: 35%;
        max-width: 565rem;
        height: 721rem;
        background: #EBEBEB;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        img {
          width: 375rem;
          height: 640rem;
        }
      }
      .example-panel-right {
        width: 40%;
        max-width: 635rem;
        height: 721rem;
        box-sizing: border-box;
        background: #F5F5F5;
        color: #666;
        font-size: 24rem;
        line-height: 34rem;
        padding: 40rem 20rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .panel-right-title {
          font-weight: bold;
          margin-bottom: 30rem;
          text-align: center;
        }
        .panel-right-text  {
          padding-left: 10rem;
          padding-right: 20rem;
          font-size: 22rem;
        }
      }
    }
  }

  // 商业合作
  .partner-box {
    width: 100%;
    height: 327rem;
    position: relative;

    .partner-content {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 900rem;
      height: 100%;
      padding: 38rem 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .partner-item {
        font-size: 30rem;
        color: #fff;

        .left-info {
          margin-top: 15rem;
          font-size: 26rem;
        }
      }
      .partner-right {
        display: flex;
        .qr-code {
          margin-left: 10rem;
          width: 250rem;
          height: 250rem;
          border-radius: 10rem;
          overflow: hidden;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/promotion.vue